const isEmpty = (value) => value.toString().length === 0;

const isRequired = (value) => typeof value === "undefined" || value === null || isEmpty(value);

export default isRequired;
